module.exports = __webpack_public_path__ + "static/media/free-car-removal-rocklea.f30e5743.png";